import { getSessionAccessToken } from "../services/sessionToken";

export type FileProxyMode = "inline" | "attachment";

const appendAccessToken = ( url: string ) => {
  const accessToken = getSessionAccessToken();
  if( !accessToken ) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${ url }${ separator }token=${ encodeURIComponent(accessToken) }`;
};

export const buildAuthenticatedFileURL = (
  mode: FileProxyMode,
  reference?: string | null
) => {
  const sanitizedReference = (reference ?? "").trim();
  const baseURL = (process.env.REACT_APP_API_URL ?? "").replace(/\/$/, "");

  if (!sanitizedReference) {
    return "";
  }

  if (
    sanitizedReference.startsWith("http://") ||
    sanitizedReference.startsWith("https://")
  ) {
    return sanitizedReference;
  }

  if (sanitizedReference.startsWith("/file/")) {
    return appendAccessToken(`${baseURL}${sanitizedReference}`);
  }

  const encodedReference = sanitizedReference
    .split("/")
    .map(encodeURIComponent)
    .join("/");
  return appendAccessToken(`${baseURL}/file/${mode}/${encodedReference}`);
};

export const buildInlineFileURL = (reference?: string | null) =>
  buildAuthenticatedFileURL("inline", reference);

export const buildAttachmentFileURL = (reference?: string | null) =>
  buildAuthenticatedFileURL("attachment", reference);
